import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { KTX2Loader } from 'three/examples/jsm/loaders/KTX2Loader.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js';
import { decoderPaths } from '@/config';

/**
 * Builds and wires every THREE loader once: GLTF with DRACO + KTX2 + Meshopt,
 * plus standalone Texture and RGBE (HDR) loaders. All share one LoadingManager
 * so global progress can be tracked centrally.
 */
export class LoaderFactory {
  readonly manager: THREE.LoadingManager;
  readonly gltf: GLTFLoader;
  readonly texture: THREE.TextureLoader;
  readonly rgbe: RGBELoader;
  readonly draco: DRACOLoader;
  readonly ktx2: KTX2Loader;

  constructor(renderer: THREE.WebGLRenderer, manager: THREE.LoadingManager = new THREE.LoadingManager()) {
    this.manager = manager;

    this.draco = new DRACOLoader(manager).setDecoderPath(decoderPaths.draco);
    this.ktx2 = new KTX2Loader(manager).setTranscoderPath(decoderPaths.ktx2).detectSupport(renderer);

    this.gltf = new GLTFLoader(manager);
    this.gltf.setDRACOLoader(this.draco);
    this.gltf.setKTX2Loader(this.ktx2);
    this.gltf.setMeshoptDecoder(MeshoptDecoder);

    this.texture = new THREE.TextureLoader(manager);
    this.rgbe = new RGBELoader(manager);
  }

  dispose(): void {
    this.draco.dispose();
    this.ktx2.dispose();
  }
}
